module.exports = __webpack_public_path__ + "./static/img/logo_login.b931fdc5d2cd9af51972dc420ab1b173.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/logo_login.png
// module id = ./client/src/assets/img/logo_login.png
// module chunks = 0